import { 
    Button, 
    FormControl, 
    FormLabel,
    FormErrorMessage, 
    Text,
    Input, 
    HStack,
    VStack,
    Box,
} from "@chakra-ui/react";
import DrawerForm from "@shared/components/drawerForm";
import useCompanyForm from "./useCompanyForm";
import type { CompanyFormProps } from "./types";

const CompanyForm = ({
    isOpen, 
    company,
    onClose, 
    onCreateCompany,
    onUpdateCompany
}:CompanyFormProps) => {
    const {
        values, 
        errors,
        touched, 
        handleChange,
        handleReset, 
        handleSubmit
    } = useCompanyForm({
        company, 
        isOpen, 
        onClose,
        onCreateCompany,
        onUpdateCompany
    })

    return(
        <DrawerForm isOpen={isOpen} onClose={onClose} size="sm" closeOnOverlayClick={false} title={company ? 'Editar Empresa' : 'Agregar Empresa'}>
            <form onSubmit={handleSubmit} onReset={handleReset}>
                <Box as="fieldset">
                    <Text as="legend" fontSize="lg" color="gray.700" fontWeight={400}>Información de la empresa</Text>
                        <VStack spacing={4} mt={2}>
                            <FormControl isInvalid={errors.nombre !== undefined && touched.nombre}>
                                <FormLabel fontSize="sm" mb={0}>Nombre de la empresa</FormLabel>
                                <Input name="nombre" type="text" value={values.nombre} onChange={handleChange}/>
                                <FormErrorMessage>{errors.nombre}</FormErrorMessage>
                            </FormControl> 
                        </VStack>
                    </Box>
                    <HStack w="100%" bg="white" bottom={0} position="sticky" mt={8} spacing={2} justifyContent="end">
                        <Button type="reset" onClick={onClose}>Cancelar</Button>
                        <Button type="submit" colorScheme="blue">Guardar</Button>           
                </HStack>     
            </form>
        </DrawerForm>
    )
}

export default CompanyForm;